import { db } from '../db/schema';

function searchText(job) {
  return `${job.title || ''} ${job.client || ''} ${(job.tags || []).join(' ')}`
    .trim()
    .toLowerCase();
}

async function updateSearchRows(jobs, archivedAt) {
  await db.searchIndex.bulkPut(
    jobs.map((job) => ({
      id: job.id,
      archivedAt,
      text: searchText(job)
    }))
  );
}

export async function getRecordCounts() {
  const jobs = await db.jobs.toArray();

  return {
    active: jobs.filter((job) => !job.archivedAt).length,
    archived: jobs.filter((job) => Boolean(job.archivedAt)).length
  };
}

export async function moveRecords(ids, archivedAt) {
  if (!ids.length) return;

  await db.transaction(
    'rw',
    db.jobs,
    db.searchIndex,
    async () => {
      const jobs = await db.jobs.bulkGet(ids);
      const existing = jobs.filter(Boolean);
      const updated = existing.map((job) => ({
        ...job,
        archivedAt
      }));

      await db.jobs.bulkPut(updated);
      await updateSearchRows(updated, archivedAt);
    }
  );
}

export function archiveRecords(ids) {
  return moveRecords(ids, Date.now());
}

export function restoreRecords(ids) {
  return moveRecords(ids, null);
}

export async function deleteRecordsPermanently(ids) {
  if (!ids.length) return;

  await db.transaction(
    'rw',
    db.jobs,
    db.blobs,
    db.searchIndex,
    async () => {
      await db.jobs.bulkDelete(ids);
      await db.blobs.bulkDelete(ids);
      await db.searchIndex.bulkDelete(ids);
    }
  );
}

export function olderThanTimestamp(days) {
  return Date.now() - days * 24 * 60 * 60 * 1000;
}

export async function getOlderRecordIds(days) {
  const cutoff = olderThanTimestamp(days);
  const jobs = await db.jobs.toArray();

  return jobs
    .filter((job) => !job.archivedAt && job.createdAt <= cutoff)
    .map((job) => job.id);
}